import graphql from "babel-plugin-relay/macro";
import styled from "styled-components";
import { FieldDetailsReportsFragment$key } from "./__generated__/FieldDetailsReportsFragment.graphql";
import { useFragment } from "react-relay";
import { DetailRow, DetailText } from "./FieldDetails";

const FieldDetailsReportsFragment = graphql`
  fragment FieldDetailsReportsFragment on FieldNode {
    reports(orderBy: ["-created"]) {
      edges {
        node {
          id
          type {
            description
            externalCode
          }
          units
          area
          date
          field {
            year
          }
        }
      }
    }
  }
`;

interface FieldDetailsReportsProps {
  fieldData: FieldDetailsReportsFragment$key;
}

const FieldDetailsReports = ({ fieldData }: FieldDetailsReportsProps) => {
  const { reports } = useFragment(FieldDetailsReportsFragment, fieldData);

  return (
    <ReportsTable>
      {reports?.edges.length ? (
        <>
          <TableHeader>
            <span>Melding</span>
            <span>Uitgevoerd op</span>
            <span>Grootte</span>
            <span>Eenheid</span>
            <span>Beheerjaar</span>
          </TableHeader>
          {reports?.edges.map((edge) => (
            <TableRow key={edge?.node?.id}>
              <span>
                {edge?.node?.type.externalCode} {edge?.node?.type.description}
              </span>
              <span>
                {new Date(edge?.node?.date).toLocaleDateString("nl-NL")}
              </span>
              <span>{edge?.node?.units || edge?.node?.area}</span>
              <span>{edge?.node?.units ? "stuk(s)" : "ha"}</span>
              <span>{edge?.node?.field?.year}</span>
            </TableRow>
          ))}
        </>
      ) : (
        <DetailRow>
          <DetailText>Er zijn geen meldingen beschikbaar</DetailText>
        </DetailRow>
      )}
    </ReportsTable>
  );
};

const ReportsTable = styled.div`
  width: 100%;
  padding-top: 16px;
`;

const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 110px 90px 60px 60px 70px;
  margin-bottom: 4px;
  span {
    color: #000;
    /* Label bold */
    font-family: Roboto;
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
  }
`;

const TableRow = styled.div`
  display: grid;
  grid-template-columns: 110px 90px 60px 60px 70px;
  padding: 8px 0;
  border-bottom: 1px solid #e5e5e5;
  span {
    color: var(--Donkergrijs, #212529);
    /* Text small - Regular */
    font-family: Roboto;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 15.6px */
  }
`;

export default FieldDetailsReports;
